import { render, staticRenderFns } from "./BaseStationTrafficChart.vue?vue&type=template&id=8271872a&scoped=true&"
import script from "./BaseStationTrafficChart.vue?vue&type=script&lang=ts&"
export * from "./BaseStationTrafficChart.vue?vue&type=script&lang=ts&"
import style0 from "./BaseStationTrafficChart.vue?vue&type=style&index=0&id=8271872a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8271872a",
  null
  
)

export default component.exports